// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"20":"739ab5a254d4c2300a73","241":"6c00f631f3db162b06c5"}[chunkId] + ".css";
};